import { ProfileHeader } from 'eshops-components-library';

export const Header = (headerProps: Record<string, unknown>) => (
  <div className="aff-social-header__container">
    <ProfileHeader {...headerProps} />
  </div>
);
